import { render, staticRenderFns } from "./AutomatedDiscountNotice.vue?vue&type=template&id=425d98e6&scoped=true&"
import script from "./AutomatedDiscountNotice.vue?vue&type=script&lang=js&"
export * from "./AutomatedDiscountNotice.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedDiscountNotice.vue?vue&type=style&index=0&id=425d98e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d98e6",
  null
  
)

export default component.exports